import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Calendar } from 'primereact/calendar';
import { Title } from 'components/Title';

import Balancesheet from './Balancesheet';
export default function BalancesheetPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [dateFrom, setDateFrom] = useState('');
const [dateTo, setDateTo] = useState('');
	return (
		<main id="BalancesheetPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('balancesheet')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="sm:col-12 lg:col-4 md:col-4 comp-grid" >
                        <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={dateFrom}
                        onChange={(e) => setDateFrom(e.value)} placeholder={$t('Date From')}   />
                    </div>
                    <div className="sm:col-12 lg:col-4 md:col-4 comp-grid" >
                        <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={dateTo}
                        onChange={(e) => setDateTo(e.value)} placeholder={$t('Date To')}   />
                    </div>
                </div>
                <div className="">
                    <div className="">
                        <div className="sm:col-12 lg:col-12 md:col-12 comp-grid" >
                            <div className="">
                                <Balancesheet dateFrom={dateFrom} dateTo={dateTo} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
